import viewSubtaskUrl from './viewSubtask.html';

class ViewSubtaskCtrl {
  constructor(Utils, sdk) {
    'ngInject';

    Utils.extendWithProps(sdk('constants'), this, [
      'TASK_INSTANCE_COMPLETED_STATUS',
      'TASK_INSTANCE_PENDING_STATUS',
    ]);
  }

  toggle() {
    if (this.clickable) {
      this.onToggle({ subtask: this.subtask });
      this.subtask.status = this.isCompleted
        ? this.TASK_INSTANCE_PENDING_STATUS
        : this.TASK_INSTANCE_COMPLETED_STATUS;
    }
  }

  get isCompleted() {
    return this.subtask.status === this.TASK_INSTANCE_COMPLETED_STATUS;
  }
}

export default {
  templateUrl: viewSubtaskUrl,
  controller: ViewSubtaskCtrl,
  controllerAs: 'ctrl',
  bindings: {
    subtask: '<',
    isTaskInstanceCompleted: '<',
    clickable: '<',
    onToggle: '&?',
  },
};
